import { SortDescriptor } from '@progress/kendo-data-query';

export const invoiceScanManagerFilter: {
  filters: any[];
  sort: SortDescriptor[];
}[] = [
  {
    filters: [
      { field: 'ocrStatus', value: 'In Progress', operator: 'neq' },
      { field: 'ocrStatus', value: 'Needs Review', operator: 'neq' },
      { field: 'ocrStatus', value: 'Failed', operator: 'neq' },
    ],
    sort: [],
  },
  {
    filters: [
      { field: 'ocrStatus', value: 'In Progress', operator: 'neq' },
      { field: 'ocrStatus', value: 'Needs Review', operator: 'neq' },
      { field: 'ocrStatus', value: 'Failed', operator: 'neq' },
      { field: 'receiptId', value: '', operator: 'isnotnull' },
    ],
    sort: [],
  },
  {
    filters: [
      { field: 'ocrStatus', value: '', operator: 'isnullorempty' },
      { field: 'receiptId', value: '', operator: 'isnull' },
    ],
    sort: [],
  },
];

export const invoiceOcrQueueFilter: {
  filters: any[];
  sort: SortDescriptor[];
}[] = [
  {
    filters: [
      { field: 'ocrStatus', value: 'Success', operator: 'doesnotcontain' },
      { field: 'ocrStatus', value: '', operator: 'notisnullorempty' },
      { field: 'isDeleted', value: 'false', operator: 'eq' },
      { field: 'receiptId', value: '', operator: 'isnull' },
    ],
    sort: [],
  },
  {
    filters: [
      { field: 'ocrStatus', value: 'In Progress', operator: 'contains' },
      { field: 'isDeleted', value: 'false', operator: 'eq' },
      { field: 'receiptId', value: '', operator: 'isnull' },
    ],

    sort: [],
  },
  {
    filters: [
      { field: 'ocrStatus', value: 'Needs Review', operator: 'contains' },
      { field: 'isDeleted', value: 'false', operator: 'eq' },
      { field: 'receiptId', value: '', operator: 'isnull' },
    ],
    sort: [],
  },
  {
    filters: [
      { field: 'ocrStatus', value: 'Failed', operator: 'contains' },
      { field: 'isDeleted', value: 'false', operator: 'eq' },
      { field: 'receiptId', value: '', operator: 'isnull' },
    ],
    sort: [],
  },
];
